import { useContext, useState } from "react";

import { Link } from "react-router-dom";

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { ArrowLeft } from 'react-bootstrap-icons';

import { AuthContext } from '../../../store/AuthContext';

import './index.css';

const MenuEsquerdo = () => {

  const { login, user } = useContext(AuthContext);

  const [statusMenu, setStatusMenu] = useState({ nivel: 1, idItemMenu: 1, idItemMenuSup: 1 });

  const [show, setShow] = useState(false);

  const menuEsquerdoShowOrClose = () => {
    if(login){
      setStatusMenu({ nivel: Number(1), idItemMenu: Number(1), idItemMenuSup: Number(1) });
      setShow(!show)
    }

  };

  //Seta a navegação para os menus filhos com base no nível e no id do menu superior
  const childsMenus = (nivelAtual: number, idItemMenuAtual: number, idItemMenuSup: number) => {
    setStatusMenu({ nivel: Number(nivelAtual), idItemMenu: Number(idItemMenuAtual), idItemMenuSup: Number(idItemMenuSup) });
  }

  return (

    <>
      <Navbar.Toggle id='menu-esquerdo' aria-controls='header-menu-dialog' onClick={() => menuEsquerdoShowOrClose()}/>
      <Navbar.Offcanvas show={show} onHide={menuEsquerdoShowOrClose}
        id='header-menu-dialog'
        className="custom-toggler.navbar-toggler"
      >
        <Offcanvas.Header closeButton onClick={() => childsMenus(1, 1, 1)}>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xll`}>
            SRO Conferência v0.0.72
          </Offcanvas.Title>
          {
            statusMenu.nivel > 1 ?
              (<Link id='menuArrowLeftSuperios' onClick={() => childsMenus(statusMenu.nivel - 1, statusMenu.idItemMenuSup, statusMenu.idItemMenuSup)} to={""}><ArrowLeft /></Link>)
              :
              (
                null
              )

          }

        </Offcanvas.Header>
        <NavDropdown.Divider key='navDropdown-divider-menu-esquerdo'/>
        <Offcanvas.Body>
          {user && user.isTemMenus ?

              user.menus.map((menu: { location: string; nome: string;}, index: number) => {

                if(menu.location === '/alterar-unidade') return null;

                return (
                  <Nav className={`justify-content-end flex-grow-1 pe-3 ${index > 0 ? 'mt-2' : ''}`} key={`nav-${index}}`}>
                      <Link key={index} to={menu.location} onClick={() => menuEsquerdoShowOrClose()}>{menu.nome}</Link>
                  </Nav>
                )
              })

          : (<Nav className="justify-content-end flex-grow-1 pe-3">
                <Link key="1" to="#" className="usuario-sem-acesso" onClick={(e) => e.preventDefault() }>Usuário sem acesso!</Link>
            </Nav>)
        }

        </Offcanvas.Body>

        <Offcanvas.Header closeButton onClick={() => childsMenus(1, 1, 1)}>
          <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xll`}>
            SRO Conferência v0.0.72
          </Offcanvas.Title>
          {
            statusMenu.nivel > 1 ?
              (<Link id='menuArrowLeftInferior' onClick={() => childsMenus(statusMenu.nivel - 1, statusMenu.idItemMenuSup, statusMenu.idItemMenuSup)} to={""}><ArrowLeft /></Link>)
              :
              (
                null
              )

          }

        </Offcanvas.Header>
      </Navbar.Offcanvas>

    </>

  )
}

export default MenuEsquerdo